// extracted by mini-css-extract-plugin
module.exports = {"root":"Views_root__2ADoz","listContainer":"Views_listContainer__M-PFT","item":"Views_item__3QOtL"};